import { Route } from "@/interfaces/Routes";

export const TasksRoutes: Route = {
  GET_TASKS_BY_SITE_KEY: "/tasks/site/{key}",
  START_TASK_BY_KEY: "/tasks/{key}/start",
  FINISH_TASK_BY_KEY: "/tasks/{key}/finish",
  PAUSE_TASK_BY_KEY: "/tasks/{key}/pause",
};
